import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './AirDuct.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/96.jpg'
import img23 from '../../Images/23.jpg'

export default function AirDuct({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE AttiAir?",
                "content": "AttiAir stands out with years of expertise and a commitment to excellence. Our professional team uses state-of-the-art equipment and techniques to ensure your air ducts are thoroughly cleaned, promoting healthier indoor air quality. We pride ourselves on reliable service and customer satisfaction."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We provide a wide range of services, including residential and commercial air duct cleaning, dryer vent cleaning, air duct inspections, air quality testing, and routine maintenance. Our goal is to optimize your HVAC system's performance and keep your air fresh and clean."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our air duct cleaning starts at just $99, and dryer vent cleaning is $79. Additionally, we offer free consultations for any repair needs, ensuring you get a clear understanding of the work required before committing."
            },
            {
                "title": "CAN YOU CLEAN AND REPAIR AT THE SAME TIME?",
                "content": "Absolutely! AttiAir specializes in providing same-day cleaning and repair services. If we identify any damage during the inspection, we can address it on the spot to save you time and restore your system's efficiency."
            },
            {
                "title": `DO YOU PROVIDE SERVICES SURROUNDING ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} and the surrounding regions. Our service area extends to a 75-mile radius, ensuring that homes and businesses in nearby towns can benefit from our top-quality air care services.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.`
            },
            {
                "title": "HOW OFTEN SHOULD AIR DUCTS BE CLEANED?",
                "content": "We recommend having your air ducts cleaned every 3 to 5 years, depending on factors such as pet ownership, allergies, or recent renovations. Regular cleaning ensures better air quality and extends the lifespan of your HVAC system."
            },
            {
                "title": "WHY IS DRYER VENT CLEANING IMPORTANT?",
                "content": "Dryer vent cleaning prevents lint buildup, reducing the risk of fires and improving your dryer's efficiency. Regular cleaning can also lower energy costs and prolong your appliance's lifespan."
            }
        ]
    };
    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for air duct) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()
                
                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="AirDuct" id="homepage">
<Helmet>
    {/* <!-- TITLE (Max 65 characters) --> */}
    <title>AttiAir - Air Duct Cleaning & Repair | Inspection & Maintenance Experts | 866-257-5796</title>

    {/* <!-- META TITLE (Max 35 characters) --> */}
    <meta name="title" property="title" content="AttiAir - Air Duct Cleaning & Repair | Inspection & Maintenance Experts | 866-257-5796" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="AttiAir - Air Duct Cleaning & Repair | Inspection & Maintenance Experts | 866-257-5796" data-react-helmet="true" />

    {/* <!-- META DETAILS --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.attiair.com/images/airduct-og.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.attiair.com/air-duct-cleaning" data-react-helmet="true" />

    {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
    <meta 
        name="description" 
        content="AttiAir Provides Professional Air Duct Cleaning, Inspection, Repair, And Maintenance Services To Improve Indoor Air Quality And HVAC Efficiency." 
        data-react-helmet="true" 
    />
    <meta 
        name="og:description" 
        property="og:description" 
        content="AttiAir Provides Professional Air Duct Cleaning, Inspection, Repair, And Maintenance Services To Improve Indoor Air Quality And HVAC Efficiency." 
        data-react-helmet="true" 
    />

    <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta 
        name="keywords" 
        content="Air Duct Cleaning, Air Duct Repair, Air Duct Inspection, HVAC Airflow, Duct Maintenance, Vent Cleaning, Residential Air Ducts, Commercial Duct Services, Improve Air Quality, Ductwork Sealing, Mold In Ducts, Allergy Relief, HVAC Optimization, Energy Efficiency, Air Duct Services Near Me, AttiAir Duct Cleaning" 
        data-react-helmet="true" 
    />
</Helmet>

            {/* AirDuctMainBanner */}
            <div className="AirDuctMainBanner" >
                <div className="AirDuctMainBannerTopLine">
                    <div className="AirDuctMainBannerTopLineLine"></div>
                    <div className="AirDuctMainBannerTopLineDot"></div>
                    <h1>AIR DUCT SERVICES</h1>
                </div>
                <div className="AirDuctMainBannerTop">
                    <img src={require(`../../Images/banner18.jpeg`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="AirDuctMainBannerTopLEFT"></div>

                </div>
                <div className="AirDuctMainBannerBottom">
                    <div className="AirDuctMainBannerBottomLeft">
                        <h1>The Air Duct Experts You've Trusted for Over 20 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Air Duct Cleaning and Repair Near Me</h2>
                        <div className="AirDuctMainBannerBottomLeftBtns">
                            <a target='_blank' href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>


                        <h4>AIR DUCT CLEANING {CitiesData.City ? CitiesData.City.toUpperCase() : "| LOCAL SERVICE"}</h4>
                        <div className="AirDuctMainBannerBottomLeftLine"></div>
                        <p>Fresh air starts with clean ducts. Over time, dust, allergens, and microbial growth accumulate in your air ducts, circulating throughout your home. Professional air duct cleaning removes these contaminants, improving indoor air quality, reducing dust buildup, and enhancing HVAC efficiency. A cleaner system means a healthier home and fresher air for you and your family.</p>
                        <p>Breathe easier with cleaner air ducts. Hidden dirt and debris in your ductwork can compromise air quality and energy efficiency. Removing these pollutants helps create a healthier living space, reduces allergens, and keeps your home cleaner. Invest in air duct cleaning and enjoy the benefits of fresh, purified air.</p>
                        <div className="MainBannerLeftRatedMain">

                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>

                            </div>
                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="AirDuctMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3><img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated AttiAir Chimney Sweep Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Licensed | Bonded | Insured AttiAir Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed AttiAir Chimney Sweep Repair" />Satisfaction Guaranteed</h3>

                    </div>
                </div>
            </div>
            {/* AirDuctMainBannerService */}
            <div className="AirDuctMainBannerService">
                <div className="AirDuctMainBannerServiceMenu">
                    <div className="AirDuctMainBannerServiceMenuBox" style={Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => true)}>
                        <h1>AIR DUCT</h1>
                    </div>
                    <div className="AirDuctMainBannerServiceMenuBox" style={!Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => false)}>
                        <h1>DRYER VENT</h1>
                    </div>
                </div>
                {Service ?
                    <div className="AirDuctMainBannerServiceInfo">
                        <div className="AirDuctMainBannerServiceInfoTop">
                            <div className="AirDuctMainBannerServiceInfoLeft">
                                <h1>AIR DUCT SERVICE</h1>
                                <img src={require(`../../Images/banner56.jpeg`)} />
                            </div>
                            <div className="AirDuctMainBannerServiceInfoRight">
                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Dust Problem" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Dust Building Up Too Fast?</h2>
                                        <h3>Constantly dusting but it never seems to go away? Your air ducts might be the culprit, spreading dust throughout your home. Our expert duct cleaning service can help keep your home fresher and dust-free.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Allergy Relief" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Struggling with Allergies or Asthma?</h2>
                                        <h3>Indoor air pollutants like dust, pet dander, and mold can worsen allergies and asthma. Our air duct cleaning service removes these contaminants, helping you and your family breathe easier.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Mold Issues" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Concerned About Mold?</h2>
                                        <h3>Mold growth in or around your air ducts is a serious health risk. Spores can spread through your ventilation system, affecting the air you breathe. Our mold removal and duct cleaning service ensures a safer, healthier home.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Energy Savings" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>If your HVAC system is working harder than it should, dirty air ducts could be the reason. Blocked airflow forces your system to use more energy, driving up costs. Our duct cleaning service boosts efficiency and saves you money.</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR AIR DUCT SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/aircleaning.png`)} alt="Air Duct Cleaning" />
                                            <h3>Air Duct Cleaning</h3>
                                            <h4>Improve Air Quality & HVAC Efficiency</h4>
                                            <h2>Eliminate dust, allergens, and contaminants from your ductwork for cleaner air, reduced allergens, and a healthier home.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airdryer.png`)} alt="Air Duct Inspection" />
                                            <h3>Air Duct Inspection</h3>
                                            <h4>Detect Issues Before They Get Worse</h4>
                                            <h2>Ensure your ductwork is free from blockages, leaks, and mold with a professional inspection to maintain optimal airflow.</h2>
                                        </a>
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airinspection.png`)} alt="Air Duct Maintenance" />
                                            <h3>Air Duct Maintenance</h3>
                                            <h4>Extend the Life of Your HVAC System</h4>
                                            <h2>Routine maintenance helps keep your ducts clean, prevents buildup, and improves HVAC performance for energy savings.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/airrepair.png`)} alt="Air Duct Repair" />
                                            <h3>Air Duct Repair</h3>
                                            <h4>Fix Leaks & Restore Airflow</h4>
                                            <h2>Repair damaged or leaky ducts to prevent energy loss, improve airflow, and enhance indoor air quality for a healthier home.</h2>
                                        </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="AirDuctMainBannerServiceInfo">
                        <div className="AirDuctMainBannerServiceInfoTop">
                            <div className="AirDuctMainBannerServiceInfoLeft">
                                <h1>DRYER VENT SERVICE</h1>
                                <img src={require(`../../Images/Before5.jpeg`)} />
                            </div>
                            <div className="AirDuctMainBannerServiceInfoRight">
                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Lint Buildup" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Clothes Taking Too Long to Dry?</h2>
                                        <h3>Are your clothes still damp after a full cycle? A clogged dryer vent restricts airflow, making your dryer work harder and less efficiently. Our professional cleaning restores performance and saves you time.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Fire Hazard" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Concerned About Fire Risks?</h2>
                                        <h3>Lint buildup in your dryer vent is a leading cause of house fires. If your dryer feels excessively hot or you notice a burning smell, it’s time for a professional cleaning to protect your home and family.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Efficiency Issues" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>A clogged dryer vent forces your dryer to work harder, increasing energy consumption and raising your utility bills. Cleaning your vent improves efficiency and helps you save money.</h3>
                                    </div>
                                </div>

                                <div className="AirDuctBenefitsBox">
                                    <div className="AirDuctBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Mold & Musty Smell" />
                                    </div>
                                    <div className="AirDuctBenefitsBoxBox">
                                        <h2>Musty Smell in Your Laundry Room?</h2>
                                        <h3>Excess moisture from a clogged dryer vent can lead to mold growth and unpleasant odors. Regular vent cleaning prevents mold buildup and keeps your laundry room fresh.</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR DRYER SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                    <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/aircleaning.png`)} alt="Dryer Vent Cleaning" />
                                    <h3>Dryer Vent Cleaning</h3>
                                    <h4>Improve Dryer Performance & Safety</h4>
                                    <h2>Remove lint buildup to improve efficiency, prevent fire hazards, and extend the lifespan of your dryer.</h2>
                                </a>

                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airdryer.png`)} alt="Dryer Vent Inspection" />
                                    <h3>Dryer Vent Inspection</h3>
                                    <h4>Detect Issues Before They Get Worse</h4>
                                    <h2>Ensure your vent system is free from blockages, damage, or lint buildup with a thorough professional inspection.</h2>
                                </a>

                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airinspection.png`)} alt="Dryer Vent Maintenance" />
                                    <h3>Dryer Vent Maintenance</h3>
                                    <h4>Keep Your Dryer Running Efficiently</h4>
                                    <h2>Routine maintenance prevents airflow restrictions, reduces energy use, and helps prevent costly repairs.</h2>
                                </a>

                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airrepair.png`)} alt="Dryer Vent Repair" />
                                    <h3>Dryer Vent Repair</h3>
                                    <h4>Fix Damage & Ensure Proper Ventilation</h4>
                                    <h2>Repair or replace damaged or disconnected vents to improve airflow and maintain dryer safety.</h2>
                                </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                }
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span><br /> SCHEDULE YOUR AIR DUCT CLEANING TODAY!</h4>
                <div className="AirDuctBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | Air Duct Services | Air Duct Inspection In Master," /></a>
                </div>
            </div>

            {/* AirDuctGoodBY */}
            <div className="AirDuctGoodBY">
                <h1>SAY GOODBYE TO DIRT AND DUST IN YOUR AIR DUCTS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience cleaner, healthier air with our professional air duct cleaning services.</h2>
                <div className="AirDuctGoodBYList">
                    <img src={require(`../../Images/97.jpg`)} />
                    <img src={require(`../../Images/96.jpg`)} />
                    <img src={require(`../../Images/23.jpg`)} />
                    <img src={require(`../../Images/12.jpg`)} />
                </div>
            </div>
            {/* airductbefore */}
            <div className="AirDuctBefore">
                <div className="AirDuctBeforeLeft">
                    <h1>THE IMPORTANCE OF CLEAN AIR DUCTS</h1>
                    <h2>Breathe Cleaner, Save Energy, and Protect Your Home</h2>
                    <h3>Your air ducts and dryer vents play a vital role in maintaining indoor air quality and home efficiency. Over time, dust, allergens, pet dander, and mold build up in your air ducts, circulating throughout your home and affecting your health. Similarly, clogged dryer vents restrict airflow, making your dryer work harder and increasing the risk of fire hazards. Regular air duct and dryer vent cleaning ensures fresh, breathable air, improves HVAC performance, and enhances the safety of your home.</h3>
                    <h2>Why Air Duct Cleaning Matters</h2>
                    <h3>
                        ✔ <b>Healthier Air</b> – Eliminate dust, allergens, and pollutants to improve indoor air quality.
                        <br />
                        ✔ <b>Increased HVAC Efficiency</b> – Clean ducts help your system run smoothly, lowering energy costs.
                        <br />
                        ✔ <b>Less Dust in Your Home</b> – Reduce the amount of dust settling on furniture and surfaces.
                        <br />
                        ✔ <b>Extended HVAC Lifespan</b> – Prevent excessive strain on your heating and cooling system.
                    </h3>
                    <h4>Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="AirDuctBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* AirDuctReviews */}
            <div className="AirDuctReviews">
                <div className="AirDuctReviewsHeader">
                    <h2>Air Duct Cleaning Reviews:</h2>
                    <h1>Customers are breathing the difference</h1>
                    <div className="AirDuctReviewsHeaderLine"></div>
                </div>
                <div className="AirDuctReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="AirDuctReviewsMenuBox">
                            <div className="AirDuctReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>
            {/* AirDuctBook */}
            <div className="AirDuctBook" id="book">
                <div className="AirDuctReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="AirDuctReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>
            {/* MainBanner2Top2 */}
            <div className="AirDuctServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>AIR DUCT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/airduct1.png`)} alt="Air Duct Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Enhance indoor air quality with AttiAir’s expert air duct cleaning. Over time, dust, pet dander, and allergens accumulate in your ducts, compromising the air you breathe. Our advanced cleaning process removes contaminants, boosts HVAC efficiency, and promotes a healthier home. Whether you're tackling allergies or simply improving airflow, we've got you covered. Trust AttiAir for cleaner air—schedule your service today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Allergen & Dust Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Sanitization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold & Mildew Treatment</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Air Quality Enhancement</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>AIR DUCT REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/ductrepair.png`)} alt="Air Duct Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Leaky or damaged air ducts can lead to energy loss, poor airflow, and higher utility bills. AttiAir’s air duct repair services ensure your HVAC system operates at peak efficiency. Our team expertly seals leaks, replaces damaged sections, and restores your ducts for maximum performance. Say goodbye to wasted energy—schedule your repair today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Duct Leak Sealing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Ductwork Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Insulation & Airflow Optimization</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />HVAC Efficiency Boost</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>UV LIGHT & SANITIZATION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/uvlightin.png`)} alt="UV Light & Sanitization" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Improve indoor air quality with AttiAir’s **UV light and sanitization solutions**. Our cutting-edge UV systems eliminate up to 99% of bacteria, viruses, and mold spores, ensuring cleaner, healthier air. Ideal for allergy sufferers and those looking to reduce airborne contaminants, our sanitization services provide peace of mind. Upgrade your home's air quality today with AttiAir’s UV solutions!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Advanced UV Light Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Bacteria & Virus Elimination</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Mold & Mildew Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Enhanced Air Purification</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>DRYER VENT CLEANING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/dryercleaning.jpg`)} alt="Dryer Vent Cleaning" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Protect your home from fire hazards and boost dryer efficiency with **AttiAir’s dryer vent cleaning services**. Clogged vents not only increase energy consumption but also pose serious safety risks. Our expert technicians clear out lint and debris, restoring proper airflow and reducing drying times. Keep your home safe and your dryer running smoothly—book your dryer vent cleaning today!</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Comprehensive Lint Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Vent Blockage Clearing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Risk Reduction</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Dryer Efficiency Optimization</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
            <h3>CHIMNEY CLEANING</h3>
            <div className="MainBanner2TopBoxBoxvLine"></div>
            <div className="MainBanner2TopBoxBoxBox">
                <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                <div className="MainBanner2TopBoxBoxBox">
                    <h4>Protect your home with AttiAir’s professional chimney cleaning. We remove dangerous creosote buildup, soot, and debris to reduce fire risks and improve your chimney's performance. Regular cleaning ensures proper airflow and a safer, more efficient fireplace. By maintaining a clean chimney, you can prevent hazardous blockages and ensure smooth, consistent operation of your fireplace. Regular chimney cleaning also helps extend the lifespan of your chimney and prevents costly repairs due to neglected maintenance.</h4>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Creosote & Soot Removal</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Blockage Clearing</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Reduction</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Draft & Ventilation</h2>
                </div>
            </div>
        </a>

        <a className="MainBanner2TopBoxBox">
            <h3>CHIMNEY REPAIR</h3>
            <div className="MainBanner2TopBoxBoxvLine"></div>
            <div className="MainBanner2TopBoxBoxBox">
                <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/chimneyrepair.jpg`)} alt="Chimney Repair" />
                <div className="MainBanner2TopBoxBoxBox">
                    <h4>Damaged chimneys can lead to leaks, structural issues, and safety hazards. AttiAir’s chimney repair services fix cracks, bricks, mortar joints, and flashing to restore your chimney’s safety, performance, and appearance. We specialize in addressing issues that could lead to expensive repairs if left unchecked, such as water damage, crumbling masonry, and improper flashing. With our repair services, your chimney will remain structurally sound, safe, and efficient for years to come.</h4>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Brick & Mortar Repair</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Water Leak Sealing</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown & Flashing Repair</h2>
                    <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Structural Restoration</h2>
                </div>
            </div>
        </a>

                </div>
            </div>

            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality air duct cleaning services over {CitiesData && CitiesData.City ? CitiesData.City : ""}, ensuring healthier and more comfortable living environments. In addition to air duct cleaning, we also offer a range of services tailored to improve indoor air quality and meet the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

